import React from "react"
import './Resultats.css'
import photos from '../Resources/pictogrammes/photos.svg'
import { FaireunDon, Titre } from "../Fonctions";
import SectionsWithIcons from "../Components/SectionsWithIcons"
// import {CarouselGoogle, Video} from "./carousel_2026"
import { getIcon } from '../files/iconsMapping';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


function importAll(r) {
    return r.keys().map(fileName => ({
      fileName,
      fileContent: r(fileName)
    }));
  }


  const imagesAll = {
    marches: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/marches', false, /\.(png|jpe?g|svg)$/i)),
    coursesenfants: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/coursesenfants', false, /\.(png|jpe?g|svg)$/i)),
    trail7km: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/trail7km', false, /\.(png|jpe?g|svg)$/i)),
    trail17km: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/trail17km', false, /\.(png|jpe?g|svg)$/i)),
    partenaires: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/partenaires', false, /\.(png|jpe?g|svg)$/i)),
    associationssante: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/associationssante', false, /\.(png|jpe?g|svg)$/i)),
    village: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/village', false, /\.(png|jpe?g|svg)$/i)),
    podium: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/podium', false, /\.(png|jpe?g|svg)$/i)),
    concerts: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/concerts', false, /\.(png|jpe?g|svg)$/i)),
    benevoles: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/benevoles', false, /\.(png|jpe?g|svg)$/i)),
    videosdrone: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/videosdrone', false, /\.(png|jpe?g|svg)$/i)),
    enfants: importAll(require.context(process.env.PUBLIC_URL + '/public/images/carousels/2026/enfants', false, /\.(png|jpe?g|svg)$/i)),
    }
    

// Trail 7 km  https://photos.app.goo.gl/KLFPtCGsUJT2dy2J9
// Trail 17 km https://photos.app.goo.gl/EPRtHY8UQ9RUTqWj7
// Courses des enfants https://photos.app.goo.gl/DzkFWnhmTKDMPby47
// Marches https://photos.app.goo.gl/w13c4F47pyU2P1aBA
// Podiums https://photos.app.goo.gl/AhD8reFhn71TQyqe7
// Bénévoles https://photos.app.goo.gl/zBxx6tEqYDuj9C5s9
// Partenaires https://photos.app.goo.gl/NFrJW1j7EbN6C7eA8
// Associations https://photos.app.goo.gl/CiLR1qYbG22J37dY6
// Village https://photos.app.goo.gl/B2DUcSjz3wPimgfi8
// Ateliers enfants https://photos.app.goo.gl/P52Msxm1HLEfguyk6
// Concerts https://photos.app.goo.gl/mxXzMKjq7TixcxaW6
// Vidéos - Drone https://photos.app.goo.gl/StE5t4GHBMatF1xL8

  const photosLinks = {
    coursesenfants : {
        titre: "Les courses des enfants",
        link: "https://photos.app.goo.gl/DzkFWnhmTKDMPby47",
        delai: 1500,
        icone: getIcon('Courses des enfants', 32)
    },
     marches : {
        titre: "Les marches",
        link: "https://photos.app.goo.gl/w13c4F47pyU2P1aBA",
        delai: 1000,
        icone: getIcon('Marches', 32)
    },

    trail7km : {
        titre: "Le trail 7 kms",
        link: "https://photos.app.goo.gl/KLFPtCGsUJT2dy2J9",
        delai: 1500,        
        icone: getIcon('Trail', 32)
    },

    trail17km : {
        titre: "Le trail 17 kms",
        link: "https://photos.app.goo.gl/EPRtHY8UQ9RUTqWj7",
        icone: getIcon('Trail', 50)
    },

    enfants : {
        titre: "Activités des enfants",
        link: "https://photos.app.goo.gl/P52Msxm1HLEfguyk6",
        delai: 1200,
        icone: getIcon('Ateliers enfants', 32)
    },

    village : {
        titre: "Le village",
        link: "https://photos.app.goo.gl/B2DUcSjz3wPimgfi8",
        delai: 2000,
        icone: getIcon('Village', 32)
    },

    partenaires : {
        titre: "Les partenaires",
        link: "https://photos.app.goo.gl/NFrJW1j7EbN6C7eA8",
        delai: 1000,
        icone: getIcon('Partenaires', 32)
    },

    associationssante : {
        titre: "Les associations de santé",
        link:"https://photos.app.goo.gl/CiLR1qYbG22J37dY6",
        icone: getIcon('Associations', 32)
    },

    podium : {
        titre: "Les podiums",
        link: "https://photos.app.goo.gl/AhD8reFhn71TQyqe7",
        icone: getIcon('Podiums', 32)
    },


    concerts : {
        titre: "Les concerts",
        link: "https://photos.app.goo.gl/mxXzMKjq7TixcxaW6",
        icone: getIcon('Concerts', 32)
    },

    benevoles : {
        titre: "Les bénévoles",
        link: "https://photos.app.goo.gl/zBxx6tEqYDuj9C5s9",
        delai: 1000,        
        icone: getIcon('Bénévoles', 32)
    },

    videosdrone : {
        titre: "Les vidéos du drone",
        link: "https://photos.app.goo.gl/StE5t4GHBMatF1xL8",
        videoOnly: true,
        icone: getIcon('Vidéos', 32)
    }

};


function CarouselGoogle({ rep, delai=3000 }) {

  const images = imagesAll[rep]
//   const images = {}

  return (
        // modules={[Autoplay, Navigation, Pagination]}
    <div className="w-full max-w-2xl mx-auto" style={{ padding: '10px' }}>
    {/* <div className="w-full max-w-2xl mx-auto p-2"> */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={10}
        slidesPerView={2}
        lazy={true}
        // autoplay={{ delay: 1000000, disableOnInteraction: false }}
        autoplay={{ delay: delai, disableOnInteraction: false }}
        // pagination={{ clickable: false }}
        // navigation
        loop
        className="xrounded-xl shadow-lg"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <img
              src={img.fileContent}
              alt={`Slide ${index}`}
              className="carousel-image"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

    // ((imagesAll[key] && imagesAll[key].length > 0) || (item.videoOnly)) && (
function Video({file}) {

    return (
      <div className="xvideo mx-auto p-4">
        <video        
            src={process.env.PUBLIC_URL + '/videos/' + file} alt={file}
            className="w-full video object-cover rounded-xl"
            autoPlay
            loop
            muted
            controls
        />
      </div>
    );
  };
  

export default function Resultats() {

    
    function LienPhotosCarousel({ icone, rep, link, titre, key, delai=5000 }) {
        return (
            <div className="carousel-google">
                <CarouselGoogle rep={rep} delai={delai}></CarouselGoogle>
                <h2>
                    <span>{icone}</span>

                    <span>{titre}</span>
                    <a href={link} target="googlephotos" className="btn btn-default">
                        <img src={photos} alt="googlephotos"/>
                    </a>
                </h2>
            </div>
        )
    }
    function LienPhotosCarousel2({ icone, rep, link, titre, key, delai = 5000 }) {
        return (
             <a href={link} target="googlephotos" className="carousel2-photo">
                <span className="carousel2-title">{titre}</span>
                <span className="carousel2-icone">
                    {icone}
                </span>
            </a>
        )
    }

    function LienVideo({ file, link, titre, delai=5000 }) {
        return (
            // <div className="wcard-prog carousel_block video">
                <Video file={file}/>
            // </div>
        )
    }

    return (
        <div id="Resultats" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/filigrane.svg)`
        }}>
            <FaireunDon />
            <div className="container" id='home'>
                <div className="row bandeau bleu bandeau-top">
                    <div className="col-sm-12 col-xs-12">
                        <h1>L'édition 2026 est terminée.
                        Un grand merci à tous et à toutes.</h1>
                    </div>
                </div>
            </div>

            {/* <div className="container">
                <SectionsWithIcons />
            </div> */}
            <div className="containerx">
                <div className="carousels2">
                    {Object.entries(photosLinks).map(([key, item], index) => (
                        ((imagesAll[key]) || (item.videoOnly)) && (

                            <LienPhotosCarousel2 titre={item.titre} icone={item.icone} rep={key} link={item.link} delai={item.delai || 4000} />
                            
                        )))}
                </div>
            </div>
        </div >
    )
}